import { IconComponent } from './types';

const LayersIcon: IconComponent = (props) => (
  <svg
    width={12}
    height={12}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path fill="none" d="M0 0h12v12H0z" />
    <path
      d="M10.25 1h-.046l-.046.009-.08.015-.046.008-.043.017-2.498.968-2.826-.989-.162-.057-.163.055-2.818.95H1.52A.752.752 0 0 0 1 2.69v7.56c0 .416.334.75.75.75h.046l.046-.009.08-.015.046-.008.043-.017 2.498-.968 2.826.989.162.057.163-.055 2.818-.95h.001A.752.752 0 0 0 11 9.31V1.75a.748.748 0 0 0-.75-.75ZM7 3.91v4.884l-2-.703V3.206l2 .703Z"
      stroke="currentColor"
    />
  </svg>
);

export default LayersIcon;
